import React from 'react';

import { CardItem, FAQsForm } from '../../components';
import { useSiteQuery } from '../../hooks';
import ErrorPage from '../_error';

import query from './index.graphql';

import styles from './index.module.scss';

const HelpCentre = () => {
  const [{ data, error }] = useSiteQuery<HelpCentreQuery>({ query });

  if (error) {
    return <ErrorPage statusCode={500} err={error} />;
  }

  const questions = data?.questions;
  const topics = data?.topics;
  const informationGuides = data?.informationGuides;
  const showQuestions = questions && questions?.length > 0;
  const showInformations = informationGuides && informationGuides?.length > 0;
  return (
    <div className={styles.helpCentre}>
      <div className="sectionWrapper">
        <div className="pageBanner">
          <div className="container">
            <h1 className="mt-1">Help Centre</h1>
            <p>Find answers to our most frequently asked questions</p>
            <FAQsForm className={styles.search} />
          </div>
        </div>
      </div>
      {showQuestions && (
        <div className="section">
          <div className="container fullMobile">
            <h2 className="mb-2 mb-md-3 mb-lg-5 center">Popular questions</h2>
            <div className="row">
              <div className="col-lg-6">
                {questions?.map(
                  (question, idx) =>
                    question &&
                    idx % 2 === 0 && (
                      <a
                        key={question.uid!}
                        href={`/help-centre/topic/${question.topic?.[0]?.slug}#${question.slug}`}
                        className={styles.question}
                      >
                        {question.title!}
                      </a>
                    ),
                )}
              </div>
              <div className="col-lg-6">
                {questions?.map(
                  (question, idx) =>
                    question &&
                    idx % 2 === 1 && (
                      <a
                        key={question.uid!}
                        href={`/help-centre/topic/${question.topic?.[0]?.slug}#${question.slug}`}
                        className={styles.question}
                      >
                        {question.title!}
                      </a>
                    ),
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="section section-purple">
        <div className="container">
          <h2 className="mb-2 mb-md-3 mb-lg-3 center">Topics</h2>
          <div className="row">
            {topics?.map(
              (topic) =>
                topic && (
                  <div key={topic.title!} className="col-lg-4 col-md-6">
                    <a href={`/${topic.uri!}`} className={styles.topic}>
                      {topic.title!}
                    </a>
                  </div>
                ),
            )}
          </div>
        </div>
      </div>
      {showInformations && (
        <div className="section">
          <div className="container">
            <h2 className="mb-2 mb-md-3 mb-lg-3 center">Information guides</h2>
            <div className="row cardsWrapper">
              {informationGuides?.map((item) => item && <CardItem key={item.uid!} item={item} />)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpCentre;
